import useAuth from "hooks/useAuth";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTaxRegimesAPIService } from "service/core/TaxRegimesAPIService";
import IndieStaticSelect from "./IndieStaticSelect";
import { useQuery } from "@tanstack/react-query";
import { Alert, Skeleton } from "@mui/material";

export const IndieTaxRegimesSelect = ({country, permissionGroups, ...params}) => {
    
    const api = useTaxRegimesAPIService();
    const { t } = useTranslation();
    const [items, setItems] = useState([]);

    const { hasPermissionGroup } = useAuth();

    const { isLoading, isError, data, error } = useQuery({
        queryKey: ['tax-regimes', country],
        queryFn: () => api.get(country),
        staleTime: 60000,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        select: (data) => {
            // Transform the data here
            return data.data.map(item => ({
                value: item.id,
                label: item.description
            }));
        }
    });

    if(permissionGroups && ! hasPermissionGroup(permissionGroups)) {
        return "";
    }

    if(isLoading) {
        return <Skeleton variant="text" />;
    }

    if(isError || !data || data?.length === 0) {
        return (
            <Alert severity="error" sx={{mb:2}}>
                Não foi possível carregar os regimes fiscais. {error?.message}
            </Alert>
        );
    }
    
    return (
        <IndieStaticSelect
            {...params}
            label={t("label.form.taxRegime")}
            options={data}
            sx={{width:300}}
            />
    );
};
